import { warehouseHolidayApis } from '@apis/dashboard/warehouseHolidayApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { WarehouseHolidayQueryParams } from '@models/WarehouseHoliday';

export const useWarehouseHoliday = createUseQuery(
  (query: WarehouseHolidayQueryParams) => ['/dashboard/warehouse-holiday/', query],
  (query) => async () => {
    const response = await warehouseHolidayApis
      .get('/dashboard/warehouse-holiday/', { query })
      .then((r) => r[200]!);
    return response;
  },
);
